import React from 'react';

export function isReactElement(child: React.ReactNode): child is React.ReactElement {
    return (child as React.ReactElement) && (child as React.ReactElement).props !== undefined;
}
